import { useEffect, useState } from 'react';
import authAxios from '../auth/authAxios';

interface Submission {
  prompt: string;
  score: number;
  feedback: string;
  lesson: string;
  submitted: string;
}

const LessonHistoryPage = () => {
  const [history, setHistory] = useState<Submission[]>([]);

  useEffect(() => {
    authAxios.get('/api/lessons/history')
      .then(res => setHistory(res.data))
      .catch(err => console.error('Failed to fetch history', err));
  }, []);

  return (
    <div className="p-6 max-w-4xl">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">Prompt Submission History</h2>
      {history.length === 0 ? (
        <p>No submissions yet.</p>
      ) : (
        <div className="space-y-4">
          {history.map((item, idx) => (
            <div key={idx} className="bg-white p-4 rounded-xl shadow border">
              <p className="text-sm text-gray-700 mb-1"><strong>Lesson:</strong> {item.lesson}</p>
              <p className="text-sm text-gray-600 mb-1"><strong>Prompt:</strong> {item.prompt}</p>
              <p className="text-sm text-gray-500 mb-1"><strong>Feedback:</strong> {item.feedback}</p>
              <div className="flex justify-between text-sm text-gray-500">
                <span><strong>Score:</strong> {item.score.toFixed(1)}</span>
                <span><strong>Date:</strong> {new Date(item.submitted).toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LessonHistoryPage;
